import { render, staticRenderFns } from "./Cnvs_table.vue?vue&type=template&id=a0431f3e&scoped=true&"
import script from "./Cnvs_table.vue?vue&type=script&lang=js&"
export * from "./Cnvs_table.vue?vue&type=script&lang=js&"
import style0 from "./Cnvs_table.vue?vue&type=style&index=0&id=a0431f3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0431f3e",
  null
  
)

export default component.exports